<template>
  <v-layout>
    <span class="body-2 pt-3">{{ title }}:</span>
    <v-menu
      menu-props="offsetY"
      :disabled="disabled"
      class="pt-2"
    >
      <v-chip
        slot="activator"
        text-color="white"
        label
        :color="selectedItem.color"
        style="height: 25px;"
        class="my-0 mx-1"
      >
        {{ selectedItem.title }}
      </v-chip>

      <v-list>
        <v-list-tile
          v-for="(item, index) in availableItems"
          :key="index"
          @click="change(item)"
        >
          <v-list-tile-title>{{ item.title }}</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
  </v-layout>
</template>

<script>
export default {
  props: ["title", "value", "items", "disabled"],
  data() {
    return {
      selected: 0,
    };
  },
  computed: {
    selectedItem() {
      return this.items.find(i => i.id === this.selected);
    },
    availableItems() {
      return this.items.filter(i => i.id !== this.selected);
    },
  },
  watch: {
    value: {
      handler() {
        this.selected = this.value ? this.value : 0;
      },
      immediate: true,
    },
  },
  methods: {
    change(item) {
      this.selected = item.id;
      this.$emit("input", item.id);
    },
  },
};
</script>
